import router from '../router';
import HTTP from './http.js';
import Auth from './auth.js';
import qs from 'qs';
import { SnackbarProgrammatic as Snackbar } from 'buefy';

HTTP.interceptors.response.use(
  response => {
    //console.log(response);
    Auth.setToken(response.headers['x-access-token'], response.headers['x-refresh-token']);
    return response;
  },
  error => {
    if (error.response.status === 401) {
      //jump to login page
      // console.log('Logout!');
      Auth.logout(() => {
        Snackbar.open('Permission denied.');
        router.push('/login');
      });
    }
    return Promise.reject(error);
  }
);

export default {
  post(url, data, cb, error) {
    var config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Access-Token': localStorage.access_token,
        'X-Refresh-Token': localStorage.refresh_token,
      },
    };

    HTTP.post(url, qs.stringify(data), config)
      .then(response => {
        //console.log(response);
        cb(response);
      })
      .catch(e => {
        error(e);
      });
  },
  get(url, cb) {
    var config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Access-Token': localStorage.access_token,
        'X-Refresh-Token': localStorage.refresh_token,
      },
    };

    HTTP.get(url, config)
      .then(response => {
        if (cb) cb(response);
      })
      .catch(e => {
        if (cb) cb(e);
      });
  },
  async getAsync(url) {
    var config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Access-Token': localStorage.access_token,
        'X-Refresh-Token': localStorage.refresh_token,
      },
    };
    return HTTP.get(url, config);
  },
  async postAsync(url, data) {
    var config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Access-Token': localStorage.access_token,
        'X-Refresh-Token': localStorage.refresh_token,
      },
    };
    return HTTP.post(url, qs.stringify(data), config);
  },
};



// WEBPACK FOOTER //
// ./src/libraries/request.js